import { ApiMetadata, ApiPaginatedResponse } from './api'

export enum RecommendationsListState {
  Idle = 'idle',
  Loading = 'loading',
  Error = 'error',
  Scheduled = 'scheduled',
}

export interface IRecommendationItem {
  _id: string
  score: number
  title: string
  type: 'course' | 'video'
  url: string
  instructors: [
    {
      name: string
      thumbnailUrl: string
    },
  ]
  provider: {
    type: 'education_provider' | 'youtube_channel'
    name: string
    thumbnailUrl: string
  }
}

export interface IRecommendation {
  _id: string
  status: 'not_generated' | 'ready' | 'generating' | 'error'
  items: Array<IRecommendationItem>
  createdAt: string
  updatedAt: string
}

export type IRecommendationOnTheList = Omit<IRecommendation, 'items'>

export interface IRecommendationResponse {
  data: ApiPaginatedResponse<IRecommendationOnTheList>
  metadata: ApiMetadata
}
